export default __webpack_public_path__ + "static/media/sound.2cb1de1f.wav";